/*
 * @Author: Vir
 * @Date: 2021-10-21 17:06:15
 * @Last Modified by: Vir
 * @Last Modified time: 2021-10-21 17:14:50
 */

// 0至9对应显示的部分，生成顺序依照顺时针，第7位为中间的元素
const digitNum = {
  0: [0, 1, 2, 3, 4, 5],
  1: [1, 2],
  2: [0, 1, 6, 4, 3],
  3: [0, 1, 6, 2, 3],
  4: [5, 6, 1, 2],
  5: [0, 5, 6, 2, 3],
  6: [0, 5, 4, 3, 2, 6],
  7: [0, 1, 2],
  8: [0, 1, 2, 3, 4, 5, 6],
  9: [0, 1, 6, 2, 5],
};

export default digitNum;
